export type RedeemStatus = 0 | 1 | 2 | 3 | 4;

export interface RedeemRequest {
  id: string;
  merchantId: string;
  merchantAddress: string;
  amount: number;
  /** ERC-20 this redeem settles in, and its label. The queue is filtered by token server-side,
   *  but each row still prefers its OWN symbol so a mislabel cannot be introduced here. */
  settlementToken?: string;
  settlementTokenSymbol?: string;
  status: RedeemStatus;
  createdAt: number;
  reason?: string;
}

export interface ApproveRedeemPayload {
  requestId: string;
  merchantId: string;
  stripeAmount: number;
}

export interface RejectRedeemPayload {
  requestId: string;
  stripeTxId?: string;
  success?: boolean;
}

export const REDEEM_STATUS: Record<RedeemStatus, string> = {
  0: "Pending",
  1: "In Review",
  2: "In Progress",
  3: "Approved",
  4: "Rejected",
};

export enum REDEEM_STATUS_CODE {
  PENDING = 0,
  INREVIEW = 1,
  INPROGRESS = 2,
  APPROVED = 3,
  REJECTED = 4,
}

export enum REDEEM_STATUS_LABEL {
  PENDING = "Pending",
  INREVIEW = "In Review",
  INPROGRESS = "In Progress",
  APPROVED = "Approved",
  REJECTED = "Rejected",
}
